import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { TranslateModule } from '@ngx-translate/core';
import { QRCodeModule } from 'angular2-qrcode';

import { PageShellComponent } from '../../layouts/page-shell/page-shell.component';
import { SpaceOpenDoorIconComponent } from '../icons/space-open-door-icon/space-open-door-icon.component';

import { CustomSpinnerDirective } from './../directives/custom-spinner.directive';
import { DisableControlDirective } from './../directives/form-disable.directive';
import { MaterialModule } from './../material.module';
import { AlphaKeyboardComponent } from './alpha-keyboard/alpha-keyboard.component';
import { SizeSelectorComponent } from './array2.0/size-selector/size-selector.component';
import { BoxesInputComponent } from './boxes-input/boxes-input.component';
import { ButtonComponent } from './button/button.component';
import { CardComponent } from './card/card.component';
import { ConfirmationComponent } from './confirmation/confirmation/confirmation.component';
import { ConfirmationPromptComponent } from './confirmation-prompt/confirmation-prompt.component';
import { ConnectionIndicatorComponent } from './connection-indicator/connection-indicator.component';
import { CountrySelectorComponent } from './country-selector/country-selector.component';
import { DeliveryListComponent } from './delivery-list/delivery-list.component';
import { DeliveryProviderComponent } from './delivery-provider/delivery-provider.component';
import { DeliveryProviderDialogComponent } from './delivery-provider-dialog/delivery-provider-dialog.component';
import { DeviceSuspendedComponent } from './device-suspended/device-suspended.component';
import { DialogLoadingComponent } from './dialog-loading/dialog-loading.component';
import { EnterCodeComponent } from './enter-code/enter-code.component';
import { FlexCubeLayoutComponent } from './flex-cube-layout/flex-cube-layout.component';
import { HandedOffConfirmationComponent } from './handed-off-confirmation/handed-off-confirmation.component';
import { HandedOffReasonComponent } from './handed-off-reason/handed-off-reason.component';
import { HeadingComponent } from './heading/heading.component';
import { HelpCenterComponent } from './help-center/help-center.component';
import { HomeComponent } from './home/home.component';
import { IconComponent } from './icon/icon.component';
import { LanguageSelectorComponent } from './language-selector/language-selector.component';
import { LaunchScreenComponent } from './launch-screen/launch-screen.component';
import { LeftMenuComponent } from './left-menu/left-menu.component';
import { LoadConfirmationComponent } from './load-confirmation/load-confirmation.component';
import { LoadingOrderComponent } from './loading-order/loading-order.component';
import { LogoComponent } from './logo/logo.component';
import { NetworkActivityPanelComponent } from './network-activity-panel/network-activity-panel.component';
import { NumericKeyboardComponent } from './numeric-keyboard/numeric-keyboard.component';
import { OrderNotAvailableComponent } from './order-not-available/order-not-available.component';
import { OrderOverflowAreaComponent } from './order-overflow-area/order-overflow-area.component';
import { OverflowAreaDialogComponent } from './overflow-area-dialog/overflow-area-dialog.component';
import { PasswordViewComponent } from './password-view/password-view.component';
import { PickupSpaceDoorIndicatorComponent } from './pickup-space-door-indicator/pickup-space-door-indicator.component';
import { ProcessingOrderComponent } from './processing-order/processing-order.component';
import { SelectOptionComponent } from './select/option/option.component';
import { SelectComponent } from './select/select.component';
import { SizeSelectionComponent } from './size-selection/size-selection.component';
import { SpaceDetailComponent } from './space-detail/space-detail.component';
import { SpinnerComponent } from './spinner/spinner.component';
import { SystemReadyComponent } from './system-ready/system-ready.component';
import { SystemUpgradeComponent } from './system-upgrade/system-upgrade.component';
import { TitleComponent } from './title/title.component';
import { ArrayLayoutComponent } from './array-layout';
import { LockerSpaceComponent } from './locker-space';
import { ButtonComponent as MobileButtonComponent } from './mobile';

@NgModule({
  declarations: [
    OverflowAreaDialogComponent,
    TitleComponent,
    IconComponent,
    SpinnerComponent,
    CustomSpinnerDirective,
    ButtonComponent,
    DialogLoadingComponent,
    CardComponent,
    HeadingComponent,
    HelpCenterComponent,
    HomeComponent,
    EnterCodeComponent,
    AlphaKeyboardComponent,
    NumericKeyboardComponent,
    PasswordViewComponent,
    ConfirmationComponent,
    LaunchScreenComponent,
    LeftMenuComponent,
    HeadingComponent,
    DisableControlDirective,
    DeliveryListComponent,
    BoxesInputComponent,
    CountrySelectorComponent,
    FlexCubeLayoutComponent,
    OverflowAreaDialogComponent,
    SpaceDetailComponent,
    DeliveryProviderDialogComponent,
    DeliveryProviderComponent,
    MobileButtonComponent,
    ArrayLayoutComponent,
    LockerSpaceComponent,
    SystemReadyComponent,
    SystemUpgradeComponent,
    SizeSelectionComponent,
    LanguageSelectorComponent,
    NetworkActivityPanelComponent,
    SelectComponent,
    SelectOptionComponent,
    PickupSpaceDoorIndicatorComponent,
    SpaceOpenDoorIconComponent,
    DeviceSuspendedComponent,
    LoadConfirmationComponent,
    ProcessingOrderComponent,
    LoadingOrderComponent,
    SizeSelectorComponent,
    ConfirmationPromptComponent,
    HandedOffConfirmationComponent,
    HandedOffReasonComponent,
    OrderNotAvailableComponent,
    OrderOverflowAreaComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    MaterialModule,
    QRCodeModule,
    ReactiveFormsModule,
    TranslateModule.forChild(),
    RouterModule,
    LogoComponent,
    ConnectionIndicatorComponent,
    PageShellComponent,
  ],
  exports: [
    TitleComponent,
    LogoComponent,
    IconComponent,
    SpinnerComponent,
    CustomSpinnerDirective,
    ButtonComponent,
    CardComponent,
    ConnectionIndicatorComponent,
    HeadingComponent,
    AlphaKeyboardComponent,
    NumericKeyboardComponent,
    PasswordViewComponent,
    LeftMenuComponent,
    HeadingComponent,
    DisableControlDirective,
    DeliveryListComponent,
    BoxesInputComponent,
    CountrySelectorComponent,
    FlexCubeLayoutComponent,
    MobileButtonComponent,
    ArrayLayoutComponent,
    SystemReadyComponent,
    SystemUpgradeComponent,
    SizeSelectionComponent,
    LanguageSelectorComponent,
    NetworkActivityPanelComponent,
    SelectComponent,
    SelectOptionComponent,
    PickupSpaceDoorIndicatorComponent,
    SpaceOpenDoorIconComponent,
    HomeComponent,
    EnterCodeComponent,
    LoadConfirmationComponent,
    ProcessingOrderComponent,
    LoadingOrderComponent,
    SizeSelectorComponent,
    ConfirmationPromptComponent,
    HandedOffConfirmationComponent,
    HandedOffReasonComponent,
  ],
})
export class ComponentsModule {}
